var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"app-button-link",attrs:{"size":"sm","variant":_vm.variant,"to":_vm.to,"disabled":_vm.isDisabled}},[_c('i',{class:_vm.icon,attrs:{"aria-hidden":"true"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }